import { useGetUserProfileQuery } from 'api/public/user/api';
import { useAuthUser } from 'features/auth/hooks/useAuthUser';
import { authSlice, selectToken } from 'features/auth/slice';
import { FC, ReactElement, useEffect } from 'react';
import { useCookies } from 'react-cookie';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import FullscreenProgress from 'shared/components/FullscreenProgress/FullscreenProgress';
import { SEARCH_PARAM } from 'shared/constants/common';
import { useTypedDispatch, useTypedSelector } from 'shared/redux/store';

const UserMiddleware: FC = ({ children }) => {
  const dispatch = useTypedDispatch();
  const [, , removeCookie] = useCookies([SEARCH_PARAM.TOKEN]);
  const [searchParams] = useSearchParams();
  const { pathname } = useLocation();
  const navigate = useNavigate();
  const token = useTypedSelector(selectToken);
  const user = useAuthUser();

  const { isError } = useGetUserProfileQuery({ token }, { skip: !token });

  useEffect(() => {
    if (isError) {
      searchParams.delete(SEARCH_PARAM.TOKEN);
      console.log(
        'useGetUserProfileQuery isError resetAuth',
        searchParams.toString()
      );
      navigate(
        { pathname, search: searchParams.toString() },
        {
          replace: true,
        }
      );
      dispatch(authSlice.actions.resetAuth());
      removeCookie(SEARCH_PARAM.TOKEN, {
        domain: process.env.REACT_APP_DOMAIN,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, isError]);

  if (!user && token) return <FullscreenProgress />;

  return children as ReactElement;
};

export default UserMiddleware;
